// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"4b57179d","513":"3b44f869","607":"4728528e","787":"c1112931"}[chunkId] + ".chunk.js";
};